import React from "react";
import ContainedCommonButtonView from "presentational/common/ContainedCommonButtonView";
import TXT from "presentational/common/multinational/TXT";
import GaHelper from "lib/gaHelper";
import { useHistory } from "react-router-dom";
import { getEssentialUrl } from "lib/urlQueryParser";
import PropTypes from "prop-types";

MembershipRecommendationButtonView.propTypes = {
  buttonLocation: PropTypes.string.isRequired
};

function MembershipRecommendationButtonView(props) {
  const { buttonLocation } = props;

  const history = useHistory();

  const handleBtnClick = () => {
    history.push(getEssentialUrl({ type: "membership" })());

    GaHelper.setGAClickEvent({
      type: "membershipRecommendationBtn",
      loc: buttonLocation
    });
  };

  return (
    <ContainedCommonButtonView onClick={handleBtnClick} design={"bold"}>
      <TXT name="btnCommonContained_membershipRecommend" />
    </ContainedCommonButtonView>
  );
}

export default MembershipRecommendationButtonView;
